import { Routes } from '@angular/router';
import { ReaderPageComponent } from './reader-page.component';

export const routes: Routes = [
  // with prefix
  { path: ':prefix/:gs1Root/01/:gtin/child/:childId', component: ReaderPageComponent },
  { path: ':prefix/:gs1Root/01/:gtin', component: ReaderPageComponent },
  { path: ':prefix/:dppId', component: ReaderPageComponent },
  { path: ':prefix/:dppId/child/:childId', component: ReaderPageComponent },

  // without prefix
  { path: ':gs1Root/01/:gtin/child/:childId', component: ReaderPageComponent },
  { path: ':gs1Root/01/:gtin', component: ReaderPageComponent },
  { path: ':dppId', component: ReaderPageComponent },
  { path: ':dppId/child/:childId', component: ReaderPageComponent },
];
